import { graphql, HeadProps } from 'gatsby';
import React, { ReactElement } from 'react';
import AbTestingService from 'app_previous/elements/abTesting/abTesting.service';
import { HeadComponent } from 'app_previous/elements/Layout/head';
import { DefaultStaticSEOPageProps } from 'src/types/pages';
import ProductOverviewView from 'app/views/product';

const ProductOverviewPage = (props: DefaultStaticSEOPageProps): ReactElement => {
  return AbTestingService<DefaultStaticSEOPageProps['data'], unknown>({
    props,
    control: {
      data: props.data,
      template: ProductOverviewView,
    },
  });
};

export const Head = (props: HeadProps<DefaultStaticSEOPageProps['data']>): JSX.Element => {
  const helmet = {
    title: 'Our Community Platform Features | Mighty Networks',
    description:
      'Mighty Networks offers all the features you need to build, grow, and monetize your community. Sell memberships, create courses, and more. 14-day free trial.',
    previewImageURL: props.data?.seoImage?.file?.url,
  };

  return (
    <HeadComponent
      helmet={helmet}
      location={props.location}
    />
  );
};

export default ProductOverviewPage;

export const pageQuery = graphql`
  query FeaturesPageQuery {
    seoImage: contentfulAsset(contentful_id: { eq: "bPu3g0XAy7uf1PLpHXnaT" }) {
      file {
        url
      }
    }
  }
`;
